var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoadingMochi = function SvgLoadingMochi(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 18",
    style: {
      enableBackground: "new 0 0 29 18"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mochipay_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web_desktop_\\u8DEF\\u908A\\u505C\\u8ECA_\\u9650\\u5E73\\u53F0",
    transform: "translate(-150.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(50.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mochipay_logo",
    transform: "translate(99.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M27.4,4.2c-1.2-1.4-3.1-2.2-5-2.2c-1.4,0-2.9,0.4-4,1.1c-1.1,0.7-2.6,0.7-3.7,0S12.4,2,11.1,2 c-4.2,0-8.3,3.5-9,7.9c-0.4,2.1,0.1,4.2,1.5,5.9C4.9,17.2,6.7,18,8.6,18c1.4,0,2.9-0.4,4-1.1c1.1-0.7,2.6-0.7,3.7,0 c1.1,0.7,2.3,1,3.7,1c4.2,0,8.3-3.5,9-7.9C29.3,7.9,28.8,5.8,27.4,4.2z"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoadingMochi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "loadingMochi.81f4c90219ce11f7dd6c5b1a9e174178.svg";